@if (form && initialized) {
  <div [formGroup]="form">
    <app-material-input-dropzone
      formControlName="floors_planning"
      [hasComments]="false"
      [max_count]="1">
    </app-material-input-dropzone>
  </div>
}
